import { observer } from 'mobx-react';
import { StandardDialog } from '@roc/ui';
import { Document } from '@roc/feature-types';
import { useDocumentStore } from '../../../hooks/useDocumentStore';
import { InsertDriveFile } from '@material-ui/icons';
import { LoanProcess } from '@roc/feature-utils';
import { CustomTaskDialog, TaskV2Type } from '@roc/feature-general-tasks';
import { LineItemUpload } from '@roc/feature-loan-details';

type Props = {
  open?: boolean;
  onClose?: () => void;
  document: Document;
};

export const InsuranceDocumentDialog = observer((props: Props) => {
  const { open, onClose, document } = props;
  const { documentStore } = useDocumentStore();
  const taskId = document?.taskId;

  return (
    taskId ? (
      <CustomTaskDialog
        title={document?.taskName}
        open={open}
        handleClose={() => {
          documentStore.loanTodosStore.fetchTodos(document?.loanId, LoanProcess.EXTENSIONS, TaskV2Type.EXTENSION_ID, document?.extensionId);
          onClose();
        }}
        dialogLogo={<InsertDriveFile />}
        dialogContent={<LineItemUpload document={document} expand={false} />}
        taskId={taskId}
      />
    ) : (
      <StandardDialog
        title={document?.taskName}
        open={open}
        handleClose={() => {
          documentStore.loanTodosStore.fetchTodos(document?.loanId, LoanProcess.EXTENSIONS, TaskV2Type.EXTENSION_ID, document?.extensionId);
          onClose();
        }}
        maxWidth="xl"
        removeContentBox={true}
        dialogLogo={<InsertDriveFile />}
        dialogContent={<LineItemUpload document={document} expand={false} />}
      />
    )
  );
});

export default InsuranceDocumentDialog;
